const NumeralService = require('./NumeralService');

class MoneyService {
  static formatToBR(value, withPrefix = true) {
    value = value.toString().replace('.', ',');

    let format = '$ 0.00[,]00';

    if (!withPrefix) {
      format = '0.00[,]00';
    }

    return NumeralService(value).format(format);
  }

  static formatBRToNumber(value, shouldIgnoreStringWithNumberFormat) {
    if (typeof value !== 'string') {
      return value;
    }

    value = value.replace('R$', '');
    if (value.includes(',')) {
      value = value.replace(/\./g, '');
      value = value.replace(',', '.');
    } else if (!shouldIgnoreStringWithNumberFormat) {
      value = value.replace('.', '');
    }

    return isNaN(value) ? 0 : Number(value);
  }

  // copied from https://github.com/dinerojs/dinero.js/blob/master/src/services/helpers.js#L73
  static countFractionDigits(number = 0) {
    if (!number) {
      return 0;
    }

    const stringRepresentation = number.toString();
    if (stringRepresentation.indexOf('e-') > 0) {
      // It's too small for a normal string representation, e.g. 1e-7 instead of 0.00000001
      return parseInt(stringRepresentation.split('e-')[1]);
    } else {
      const fractionDigits = stringRepresentation.split('.')[1];
      return fractionDigits ? fractionDigits.length : 0;
    }
  }

  // copied from https://github.com/dinerojs/dinero.js/blob/develop/src/services/calculator.js#L4
  static floatMultiply(a, b) {
    const getFactor = number => Math.pow(10, MoneyService.countFractionDigits(number));
    const factor = Math.max(getFactor(a), getFactor(b));
    return (Math.round(a * factor) * Math.round(b * factor)) / (factor * factor);
  }

  static toCents(value) {
    if (MoneyService.countFractionDigits(value) > 2) {
      throw new Error('Cannot convert to cents with more than 2 decimals');
    }
    return MoneyService.floatMultiply(value, 100);
  }

  static truncate(value) {
    if (!value) {
      return value;
    }

    return Math.trunc(value * 100) / 100;
  }

  static round(value) {
    if (!value) {
      return value;
    }

    return Math.round(value * 100) / 100;
  }

  static ceil(value) {
    if (!value) {
      return value;
    }

    return Math.ceil(value * 100) / 100;
  }
}

module.exports = MoneyService;
